import { MB_CustomHTMLCanvasElement } from './customCanvasForWeb';
import { MB_CustomHTMLVideoElement } from './customVideoForWeb';
import { MB_CustomWindowNavigatorForWeb } from './customWindowNavigatorForWeb';

interface IFileReader {
  onabort: (evt: any) => void;
  onerror: (evt: any) => void;
  onload: (evt: any) => void;
  result: string | ArrayBuffer | null;
  loading: number;
  error: any;
  readAsArrayBuffer: (blob: Blob) => void;
  readAsBinaryString: (blob: Blob) => void;
}

type FileReaderClass = {
  new (...args: any[]): IFileReader;
};

interface MB_CustomHTMLImageElement {
  width: number;
  readonly naturalWidth: number;
  height: number;
  readonly naturalHeight: number;
}

interface HTMLElementTagNameMap {
  canvas: MB_CustomHTMLCanvasElement;
  video: MB_CustomHTMLVideoElement;
}

interface ElementCreationOptions {
  is?: string;
}

export interface MB_BroadcastChannel {
  new (channelName: string): MB_BroadcastChannel;

  postMessage: (message: any) => void;
  addEventListener(type: string, listener: (event: any) => void): void;
  removeEventListener(type: string, listener: (event: any) => void): void;
}

interface MB_CustomWindowForWeb {
  addEventListener: (type: string, callback: (event: any) => void) => void;
  removeEventListener: (type: string, callback: (event: any) => void) => void;
  postMessage: (message: any, target: string) => void;
  opener: {
    postMessage: (message: any, target: string) => void;
  };
  open: (url: string, name: string, ...windowFeatures: string[]) => void;
  close: () => void;
  outerWidth: number;
  outerHeight: number;
  screenX: number;
  screenY: number;
  FileReader: FileReaderClass;
  getVideoDuration: (url: string) => Promise<number>;
  document: {
    /**
     * Creates an instance of the element for the specified tag.
     * @param tagName The name of an element.
     */
    createElement<K extends keyof HTMLElementTagNameMap>(tagName: K, options?: ElementCreationOptions): HTMLElementTagNameMap[K];
    createElement(tagName: string, options?: ElementCreationOptions): HTMLElement;
    fullscreenElement: Element;
    webkitFullscreenElement: Element;
    msFullscreenElement: Element;
  };
  readonly devicePixelRatio: number;
  getCurrentFullScreenElement: () => Element;
  navigator: MB_CustomWindowNavigatorForWeb;
  location: {
    replace: (url: string) => void;
    assign: (url: string) => void;
  };
  BroadcastChannel: MB_BroadcastChannel;
}

const MB_customWindowForWeb = global as unknown as MB_CustomWindowForWeb;

MB_customWindowForWeb.getCurrentFullScreenElement = () => {
  return (global as unknown as any).document.fullscreenElement;
};

MB_customWindowForWeb.getVideoDuration = (url: string) => {
  return new Promise<number>((resolve, reject) => {
    const failureTimeout = setTimeout(() => reject('Timed out'), 5000);
    try {
      const video = MB_customWindowForWeb.document.createElement('video');

      video.src = url;
      video.autoplay = false;
      video.onloadeddata = function () {
        clearTimeout(failureTimeout);
        resolve(video.duration);
      };
      video.addEventListener('error', error => {
        reject(error);
        clearTimeout(failureTimeout);
      });
    } catch (error) {
      clearTimeout(failureTimeout);
      reject(error);
    }
  });
};

export { MB_customWindowForWeb };
export type { MB_CustomHTMLImageElement };
